import React from 'react';

/**
 * Search component.
 */
const Search = () => (
  <input
    type="text"
    className="form-control mr-sm-2"
    aria-label="City input"
    placeholder="Type a city name..."
    disabled
  />
);

export default Search;
